'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoFlashOff = function IoFlashOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm9 35.3c-5.4-3-9-8.7-9-15.3 0-9.7 7.8-17.5 17.5-17.5 1.9 0 3.7 0.3 5.3 0.9 0.2 0 0.2 0 0.4 0.1 0.9 0.3 1.9 0.7 2.7 1.2 5.4 3 9.1 8.7 9.1 15.3 0 9.7-7.8 17.5-17.5 17.5-1.9 0-3.7-0.3-5.3-0.9-0.2 0-0.2 0-0.4-0.1-0.9-0.3-1.9-0.6-2.7-1.1z m-2.3-23c-1.5 2.2-2.5 4.8-2.5 7.7 0 5.1 2.8 9.5 7.1 11.7 0.4 0.3 1 0.6 1.4 0.7 0.2 0.1 0.3 0.1 0.4 0.2 0.7 0.2 1.5 0.4 2.3 0.5 0.7 0.2 1.4 0.2 2.1 0.2 2.9 0 5.5-1 7.7-2.5l-4-4.2 2.8-3.1 4.3 4.2c1.5-2.2 2.5-4.8 2.5-7.7 0-5.2-2.9-9.6-7.1-11.8-0.5-0.2-1-0.5-1.4-0.6-0.2-0.1-0.3-0.1-0.4-0.2-0.7-0.2-1.5-0.4-2.3-0.5-0.7-0.2-1.4-0.2-2.1-0.2-2.9 0-5.6 1-7.8 2.5l4.1 4.1-2.8 3.2z m7.2 18.2l3-8.9h-6.7l10.9-12.1-3 8.9h6.7z' })
        )
    );
};

exports.default = IoFlashOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/flash-off.js
// module id = 2263
// module chunks = 0